import React, { Component, useState } from 'react';
import { Trans, withI18n } from '@lingui/react';
import addToMailchimp from 'gatsby-plugin-mailchimp'

function NewsLetterForm({onFormSubmit}) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isDisabled, setDisableState] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();

    addToMailchimp(email) // listFields are optional if you are only capturing the email address.
    .then(data => {
      let msg = '';
      
      if (data.result === 'success')  {
        msg = 'Thank you for signing up to our newsletter and joining our faction, human.';

        onFormSubmit(msg);
      } else {
        if (data.msg.indexOf('already subscribed') > -1) {
          msg = `${email} is already subscribed to our NewsLetter.`
        } else {
          msg = data.msg;
        }

        setMessage(msg);
        // setDisableState(true);
      }
    })
    .catch(() => {
      setMessage('Something is wrong. Please try again later.')
    })
  }

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    setEmail(value);
  }

  const reset = () => {
    setEmail('');
    setMessage('');
    setDisableState(false);
  }

  return (
    <div className="form-wrapper">
      <form 
        className="form form--inquiry"
        method="post" 
        style={{opacity: isDisabled ? .5 : 1}}
        onSubmit={handleSubmit}
      >
        <fieldset>
          <label htmlFor="email">
            <span className="form__label"><Trans>Email Address</Trans></span>
            <input name="email" required id="email" type="email" disabled={isDisabled} value={email} onChange={handleInputChange} />
          </label>
        </fieldset>
        <div className="form__actions">
          <button className="button button--black" disabled={isDisabled} type="submit">
            <Trans>Subscribe</Trans>
          </button>
        </div>
      </form>
      { message && <div className="message">{ message }</div> }
    </div>
  )
}

export default withI18n()(NewsLetterForm);
